export default function() {
	let debug = false;

	const responsiveOembedWrapping = () => {
		debug ? console.log('responsiveOembedWrapping()') : false;

		const videoIframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]');
		debug ? console.log(videoIframes) : false;

		videoIframes.forEach((iframe) => {
			debug ? console.log('found a youtube or vimeo iframe') : false;
			const wrapperDiv = document.createElement('div');

			wrapperDiv.classList.add('embed', 'embed--16by9');
			iframe.parentNode.replaceChild(wrapperDiv, iframe);
			wrapperDiv.appendChild(iframe);
		});
	};

	// Hold off for half a second and let the iframes generate in the DOM
	setTimeout( () => {
		responsiveOembedWrapping();
	}, 500); // wait half a second before firing to avoid firing before the iframes build
}
